// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDPxgtzsrFSKNCdKuxRbPfV6Jv9Xcwuk0Y",
    authDomain: "handy-plus-5a529.firebaseapp.com",
    projectId: "handy-plus-5a529",
    storageBucket: "handy-plus-5a529.appspot.com",
    messagingSenderId: "510031351837",
    appId: "1:510031351837:web:c95c4380bee4c08d3c36f4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;